import FastMarquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/lib/data";

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[color:var(--ink-line)] py-8 md:py-10 bg-[color:var(--bone)]"
    >
      <FastMarquee gradient={false} speed={22} pauseOnHover={false}>
        {MARQUEE_WORDS.concat(MARQUEE_WORDS).map((w, i) => (
          <span
            key={i}
            className="marquee-serif inline-flex items-center gap-8 md:gap-14 px-6 md:px-10 whitespace-nowrap"
            style={{ fontSize: "clamp(48px, 8vw, 128px)", lineHeight: 1 }}
          >
            {w}
            <span
              aria-hidden
              className="text-[color:var(--rust)] font-serif-display not-italic"
              style={{ fontSize: "0.55em" }}
            >
              ✦
            </span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
